export const COOKIE_DEVICE_ID = 'x-bt';

// Session info is base64 encoded. Note: if we move this to encryption, we likely need to move
// The encryption private key OUT of common, or it might get packaged and shipped down to the client
export const COOKIE_SESSION_KEY = 'x-s';

// Indicates whether this request comes from react (shef-web) or the app (consumer-app)
export const COOKIE_SOURCE = 'x-source';

/**
 * Which consumer storefront the request came through. Possible values are 'shef' or 'tablerun'.
 * Defaults to 'shef' when absent.
 */
export const COOKIE_STOREFRONT = 'x-storefront';

// First-touch attribution cookie set by shef-tag.js (on 3P landing pages) when a visitor
// first hits any shef.com property. Long-lived (~2y) and write-once. JSON-encoded.
export const COOKIE_FIRST_TOUCH = 'x-ft';

/**
 * CCPA ad-consent decision, JSON-encoded as {@link ICcpaConsent}.
 *
 * A cookie rather than localStorage because consent has to hold across every shef.com
 * origin — shef-web, the shef-next `/lp/` pages, and partner pages on subdomains like
 * `try.shef.com`. localStorage is scoped per origin, so a decision recorded on shef.com
 * is invisible to all of them, and each origin would re-prompt and meanwhile treat the
 * visitor as un-consented.
 */
export const COOKIE_CCPA_CONSENT = 'x-ccpa';
